import FreeSpinReel from "./FreeSpinReel";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class FreeSpinReelStatic extends FreeSpinReel {
    constructor(scene, x, y, index, orientation) {
        super(scene, x, y, index, orientation);
    }
    createReelMask(orientation) {
        if (this.reelMask) {
            this.reelMask.destroy();
            this.container.clearMask(true);
            this.reelMask = undefined;
        }
        const visibleHeight = this.cellSize.height * this.numOfCellsPerReel;
        const currentOrientation = orientation;
        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;
        if (currentOrientation == "portrait") {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_X; //155
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_Y; //796
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.PORTRAIT_SCALE;
        }
        else {
            xContainer = this.container.x + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_X; //525
            yContainer = this.container.y + ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_Y; //280
            scale = ResourcesDispatcher.GAME_CONSTANTS.STATIC_MASK_OFFSET.LANDSCAPE_SCALE;
        }
        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.reelMask = this.scene.make.graphics({ x: 0, y: 0, add: false });
        this.reelMask.fillRect(xContainer, yContainer, this.cellSize.width, visibleHeight).setScale(scale);
        this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.reelMask));
    }
    configureFreeSpinTween() {
        this.resetFlagsAndCounters();
        this.spinProgress = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height },
            paused: true,
            loop: -1,
            delay: 0,
            yoyo: false,
            duration: this.spinAnimationDuration,
            onStart: () => {
                this.freeSpinCells.forEach(cell => {
                    cell.resetLayer();
                });
                this.turnOn();
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }
                this.freeSpinCells.forEach((cell) => {
                    // Position
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }
                this.virtualReelPosition = (this.virtualReelPosition + 1) % this.scene.freeSpinGameArea.virtualGrid[this.index].length;
                this.scene.freeSpinGameArea.increaseLoopCounter(this.index);
                this.reIndexCells();
                if (this.mustStop) {
                    this.freeSpinCells[0].setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                    this.freeSpinCells[this.lastCellIndex].setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);
                    // Real memo
                    for (let i = 1; i < this.lastCellIndex; i++) {
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (i - 1)];
                        this.freeSpinCells[i].setCellInfo(realmemo);
                    }
                    this.spinProgress.stop();
                    this.bounce();
                }
                else if (!this.canStop) { // Fake memo
                    const xmemo = this.scene.freeSpinGameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.freeSpinCells[this.lastCellIndex].setCellInfo(xmemo);
                }
                else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);
                    }
                    else if (this.realMemoIndex < this.lastCellIndex) { // Visible cell, real memo
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)];
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(realmemo);
                    }
                    else if (this.realMemoIndex === this.lastCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        this.freeSpinCells[this.lastCellIndex].setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                        this.spinProgress.stop();
                        this.bounce();
                    }
                    this.realMemoIndex++;
                }
            }
        });
    }
    bounce() {
        if (this.stopped) {
            return;
        }
        this.bounceTween1 = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75 },
            yoyo: false,
            duration: this.spinAnimationDuration * 0.75,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.freeSpinCells.forEach((cell) => {
                    cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onComplete: () => {
                this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);
                // Turbo on(low volume) or forced stop
                if (this.gameLogicVariableManager.getTurbo() || this.mustStop) {
                    // TODO: add stop sound
                }
                else {
                    let specificSound = false;
                    if (this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME) {
                        // if there is a multiplier in the reel, play the sound
                        specificSound = this.freeSpinCells.some(cell => cell.getMemo() > 0 && cell.getIndex() > 0 && cell.getIndex() < (this.lastCellIndex));
                    }
                }
                this.bounceTween2 = this.scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 6,
                    //TODO implementare ONSTART
                    onUpdate: () => {
                        this.freeSpinCells.forEach((cell) => {
                            cell.getContainer().y = this.cellPosition[cell.getIndex()].y + this.spinProgressValue.value;
                        });
                    },
                    onComplete: () => {
                        this.freeSpinCells.forEach((cell) => {
                            cell.checkLayer();
                        });
                        this.scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                this.scene.freeSpinGameArea.notifySpinCompleted(this.index);
                            },
                        });
                    }
                });
                if (this.spinMainButtonTween && this.spinMainButtonTween.isPlaying()) {
                    this.spinMainButtonTween.stop();
                    window.isButtonSpinning = false;
                }
            }
        });
    }
}
